<template>
  <div class="pa-5">
    <v-card class="elevation-10" shaped v-if="staff">
      <v-card-title>
        <span>รายงานการดำเนินการ {{ staff.display_name }}</span>
      </v-card-title>
      <v-card-text class="px-0" v-for="type in staff.academic_types" :key="type.id">
        <div class="px-4 d-flex flex-row align-center">
          <h4>{{ type.name }}</h4>
          <v-spacer></v-spacer>
          <v-btn small tile color="success" @click="report(type.id)">รายงาน</v-btn>
        </div>
        <div class="px-4 py-2" v-if="type.reports && type.reports.length === 0">
          <p>--ไม่มีการรายงาน--</p>
        </div>
        <v-simple-table v-else>
          <template v-slot:default>
            <thead>
              <tr>
                <th style="width: 15%;">วัน/เดือน/ปี</th>
                <th style="width: 25%;">การดำเนินการ</th>
                <th style="width: 30%;">รายละเอียด</th>
                <th style="width: 15%;">หมายเหตุ</th>
                <th style="width: 15%;">#</th>
              </tr>
            </thead>

            <tbody v-for="row in type.reports" :key="row.id">
              <tr>
                <td class="text-top">{{ row.operation_date | transform_date }}</td>
                <td class="py-2 text-top">{{ row.report_type.name }}</td>
                <td class="py-2 text-top">{{ row.description }}</td>
                <td class="text-top">{{ row.note || '-' }}</td>
                <td>
                  <v-menu offset-y transition="fade-transition">
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn icon v-on="on" v-bind="attrs"><v-icon>mdi-dots-vertical</v-icon></v-btn>
                    </template>
                    <v-list>
                      <v-list-item @click="edit(row)">
                        <v-list-item-icon><v-icon>mdi-pencil</v-icon></v-list-item-icon>
                        <v-list-item-title>แก้ไข</v-list-item-title>
                      </v-list-item>
                      <v-list-item @click="confirmDestroy(row.id)">
                        <v-list-item-icon><v-icon>mdi-delete</v-icon></v-list-item-icon>
                        <v-list-item-title>ลบ</v-list-item-title>
                      </v-list-item>
                    </v-list>
                  </v-menu>
                </td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
      </v-card-text>
    </v-card>

    <v-dialog v-model="formDialog" max-width="500" persistent>
      <v-card>
        <v-card-title>รายงานการดำเนินการ</v-card-title>
        <v-subheader>วันที่ดำเนินการ</v-subheader>
        <v-card-text>
          <v-date-picker locale="th" class="elevation-1 mb-5" v-model="form.operation_date" full-width></v-date-picker>
        </v-card-text>
        <v-card-text>
          <v-select outlined dense v-model="form.report_type_id" label="การดำเนินการ" :items="report_types" item-text="name" item-value="id"></v-select>
          <v-textarea outlined dense v-model="form.description" label="รายละเอียด" rows="2"></v-textarea>
          <v-text-field outlined dense v-model="form.note" label="หมายเหตุ"></v-text-field>
        </v-card-text>       
        <v-card-actions>
          <v-btn color="success" @click="submit">บันทึก</v-btn>
          <v-btn color="error" @click="closeDialog">ปิด</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <confirmDialog
      :dialog="destroyDialog"
      message="คุณต้องการลบข้อมูลนี้ใช่หรือไม่?"
      v-on:confirm="destroy"
    />
  </div>
</template>

<script>
import confirmDialog from '@/components/ConfirmDialog';

export default {
  components: {
    confirmDialog: confirmDialog
  },
  filters: {
    transform_date(value) {
      const event = new Date(value);
      const options = { year: 'numeric', month: 'long', day: 'numeric' };
      
      return event.toLocaleDateString('th-TH', options);
    }
  },
  data: () => ({
    formDialog: false,
    destroyDialog: false,
    destroySelected: '',
    dialogType: 'NEW' | 'EDIT',
    staff: null,
    form: {
      academic_type_id: '',
      report_type_id: '',
      description: '',
      note: '',
      operation_date: new Date().toISOString().substr(0, 10),
    }
  }),
  computed: {
    mis_id() { return this.$route.params.mis_id },
    report_types() { return this.$store.state.academic.report_types }
  },
  mounted() {
    this.loadStaff(this.mis_id);
  },
  methods: {
    loadStaff(mis_id) {
      this.$store.dispatch('academic/getStaff', mis_id).then(data => this.staff = data);
    },
    submit() {
      this.$store.dispatch(this.dialogType === 'NEW' ? 'academic/storeReport' : 'academic/updateReport', { formData: this.form, mis_id: this.mis_id })
        .then(res => {
          this.formDialog = false;
          this.loadStaff(this.mis_id);
          this.clearForm();
          this.$store.commit('SHOW_SNACKBAR', {
            color: 'success',
            message: res.message
          });
        }).catch(() => {
          this.academic_dialog = false;
          this.clearForm();
          this.$store.commit('SHOW_SNACKBAR', {
            color: 'error',
            message: 'เกิดข้อผิดพลาดบางอย่าง'
          });
        })
    },
    edit(data) {
      this.dialogType = 'EDIT';
      this.formDialog = true;
      this.form = {
        id: data.id,
        report_type_id: data.report_type_id,
        academic_type_id: data.academic_type_id,
        description: data.description,
        note: data.note,
        operation_date: data.operation_date,
      }
    },
    confirmDestroy(id) {
      this.destroyDialog = true;
      this.destroySelected = id;
    },
    destroy(condition) {
      if(condition) {
        this.$store.dispatch('academic/destroyReport', this.destroySelected).then(res => {
          this.destroyDialog = false;
          this.loadStaff(this.mis_id);
          this.$store.commit('SHOW_SNACKBAR', {
            color: 'success',
            message: res.message
          });
        }).catch(() => {
          this.destroyDialog = false;
          this.$store.commit('SHOW_SNACKBAR', {
            color: 'error',
            message: 'เกิดข้อผิดพลาดบางอย่าง'
          });
        })
      } else {
        this.destroyDialog = false;
      }
    },
    report(type) {
      this.dialogType = 'NEW';
      this.form.academic_type_id = type;
      this.formDialog = true;
    },
    closeDialog() {
      this.formDialog = false;
    },
    clearForm() {
      this.form = {
        report_type_id: '',
        academic_type_id: '',
        description: '',
        note: '',
        operation_date: new Date().toISOString().substr(0, 10),
      }
    }
  }
}
</script>